// Finar İ9 — FormFill bölüm sonu gezinmesi. Kopya TEK kaynak (satır içi yazılmaz).
export const SECTION_PAGER_COPY = {
  navLabel: "Bölümler arası gezinme",
  prev: "← Önceki bölüm",
  next: "Sonraki bölüm →",
} as const;

export interface PagerSection {
  id: string;
  label: string;
  order: number;
}

/** Etkin bölümün sıraya göre önceki/sonraki komşusu (yoksa null). */
export function adjacentSections<T extends PagerSection>(
  sections: readonly T[],
  activeSectionId: string | null,
): { prev: T | null; next: T | null } {
  const ordered = [...sections].sort((a, b) => a.order - b.order);
  const idx = ordered.findIndex((s) => s.id === activeSectionId);
  if (idx < 0) return { prev: null, next: null };
  return { prev: ordered[idx - 1] ?? null, next: ordered[idx + 1] ?? null };
}
